import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import { TestReportingDataService } from '../../data-services/testReporting.service';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ngfModule } from "angular-file";
import { UnRejectDialogComponent } from '../common/unreject.dialog.component';
import { RejectReqasonDialogComponent } from '../common/rejectReason.dialog.component';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'app-uploadSendoutReports-list',
  templateUrl: './uploadSendoutReports.list.html',
  providers: [MessageService],
  imports: [ButtonModule, Dialog, AccordionModule, FormsModule, Toast, CommonModule, TableModule, DatePickerModule, RadioButtonModule, ngfModule, UnRejectDialogComponent, RejectReqasonDialogComponent, HasClaimDirective]
})
export class UploadSendoutReportListComponent implements OnInit {

  constructor(
    private requisitionTestService: RequisitionTestDataService,
    private messageService: MessageService,
    private testReportingService: TestReportingDataService) {
  }

  initialLoad: boolean;
  searchDisabled: boolean = true;
  dataRows;
  filterDisplay: '';
  filter: any = { facilityName: '', labName: '', patientName: '', patientDateOfBirth: '', receivedDate: null, labSerialNumber: '', gridFilter:'' };
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  totalRecords: any;
  cols: any[];
  loading: boolean;
  selectedStatus: SelectItem;
  showSpinner: boolean = false;
  showRejectDialog: boolean = false;
  showUnRejectDialog: boolean = false;
  editRequisitionModalVisible: boolean = false;


  selectedRow: any = null;
  selectedAccession: string = null;
  selectedRequisitionId: number = null;
  selectedRequisitionTestId: number = null;
  selectedRequisitionTestRejectionId: number = null;
  lastLoad: any = {};

  //File uploader fields
  showUploadDocument: boolean = false;
  files: File[] = [];
  base64FileContent: string[] = [];
  acceptTypes: string = "application/pdf";
  //maxFileSize: number = 102400;
  lastFileAt: Date;
  //lastInvalids: any;
  uploadOption: string = null;
  showUploadOptions: boolean = false;
  uploadFormData: FormData;
  fileUploading: boolean = false;


  ngOnInit() {

    this.cols = [
      { field: 'PatientFirstName', header: 'First Name' },
      { field: 'PatientLastName', header: 'Last Name' },
      { field: 'PatientBirthDate', header: 'Birth Date' },
      { field: 'Physician', header: 'Provider' },
      { field: 'FacilityName', header: 'Facility' },
      { field: 'LabSerialCollectionDate', header: 'Collection Date' },
      { field: 'LabSerialNumber', header: 'SID' },
      { field: 'LabTestDescription', header: 'Test' },
      { field: 'MedTekTestStatus', header: 'Status' },

    ];
    this.loading = false;
    this.initialLoad = true;
  }

  public filterChanged() {
    console.log('filter changed');
    this.searchDisabled =
      (this.loading || !this.filter ||
        (
          (!this.filter.labSerialNumber || this.filter.labSerialNumber.length == 0) &&
          (!this.filter.facilityName || this.filter.facilityName.length == 0) &&
          (!this.filter.labName || this.filter.labName.length == 0) &&
          (!this.filter.patientName || this.filter.patientName.length == 0) &&
          (!this.filter.patientDateOfBirth || this.filter.patientDateOfBirth.length == 0)
        )
      );

    console.log(this.searchDisabled);
  }

  public handleGlobalGridSearchKey(event, gridData) {
    if (event.keyCode == 13) {
      gridData.filterGlobal(event.target.value, 'contains');
      event.preventDefault();
    }
  }

  public onDateSelect(event, gridData, fieldName) {
    gridData.filter(this.formatDate(event.target.value), fieldName, 'equals')
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  searchButtonClicked() {
    if (this.searchDisabled) {
      return;
    }
    this.lastLoad = {};
    this.initialLoad = false;
    this.filter.gridFilter == '';
    this.loadGridData(null);
  }

  
  public loadGridData(event: LazyLoadEvent) {
    if (event) {
      this.lastLoad = event;
    }
    else {
      this.lastLoad.first = 0;
      this.lastLoad.rows = 20;
      event = this.lastLoad;
    }

    if (this.initialLoad == true) //do not move this code to the top of this function, loadGridData is called by the grid and he passes in the event defaults
    {
      return;
    }

    this.loading = true;

    this.testReportingService.searchMedtekSendoutTests(event.first, event.rows, event.sortField, event.sortOrder, this.filter.facilityName, this.filter.labName, this.filter.patientName, this.filter.patientDateOfBirth, this.filter.receivedDate, this.filter.labSerialNumber, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.dataRows = data.rows;
      this.loading = false;
    });
  }

  public getRequisitionTestResultReport(id: number) {
    this.requisitionTestService.getTestResultReport(id).subscribe((response: any) => {
      if (response) {
        let file = new Blob([response], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Unable to retrieve Report PDF ', detail: 'Failed: ' + err.error });
    });
  }

  public rejectTest(accession, requisitionTestId, row) {
    console.log(`RejectTest: ${accession},${requisitionTestId}`);
    this.selectedAccession = accession;
    this.selectedRequisitionTestId = requisitionTestId;
    this.rejectRow = row;
    this.showRejectDialog = true;

  }

  rejectRow: any;
  rejectDescription: string;
  rejectReasons: any[];
  public rejectDialogOnClosed(value) {
    console.log(`rejectReasonOnClosed ${value}`);
    this.rejectRow.rejectDescription = this.rejectDescription;
    this.rejectRow.rejectReasons = this.rejectReasons;
    this.testReportingService.rejectTest(this.rejectRow).subscribe((data: any) => {
      this.loadGridData(this.lastLoad);
    }, (err) => {
      console.log(`Error: ` + err.error)
      this.messageService.add({ severity: 'error', summary: 'Error Rejecting Test ', detail: 'Failed: ' + err.error });
    });
  }

  public unrejectTest(accession, requisitionId, requisitionTestId, requisitionTestRejectionId) {
    console.log(`unrejectTest: ${requisitionTestRejectionId}`);
    this.selectedAccession = accession;
    this.selectedRequisitionId = requisitionId;
    this.selectedRequisitionTestId = requisitionTestId;
    this.selectedRequisitionTestRejectionId = requisitionTestRejectionId;
    this.showUnRejectDialog = true;
  }

  public unrejectDialogOnClosed(value) {
    console.log(`rejectReasonOnClosed ${value}`);
    if (value) {
      this.loadGridData(this.lastLoad);
    }
  }

  public showUploadDocumentDialog(selectedRow) {
    this.selectedRow = selectedRow;
    this.showUploadDocument = true;
    this.showUploadOptions = (selectedRow.RequisitionTestResultId && selectedRow.RequisitionTestResultId > 0 && selectedRow.LabTekTestStatus == 'Completed');
  }

  public uploadFilesChanged() {
    console.log(`Upload Files Changed`);
    this.lastFileAt = new Date();
    var acceptablePrefix = this.selectedRow?.LabSerialNumber + '_01';

    for (var i = this.files.length - 1; i >= 0; i--) {
      var fileName = this.files[i].name;
      if (!fileName.startsWith(acceptablePrefix)) {
        this.messageService.add({ severity: 'warn', summary: 'File ' + fileName + ' not added. File names must start with ' + acceptablePrefix, life: 5000 });
        this.files.splice(i, 1); 
      }
    }

    /*Duplicate file detection, so the user doesn't upload multiple PDFs with the same file name.*/
    var newFileContainsDuplicate = false;
    if(this.files.length > 1) { /*Don't need to bother checking for duplicates if there's only one file*/
      const tempFiles = [];
      for(var i = 0; i < this.files.length; i++) {
        if(tempFiles.indexOf(this.files[i].name.toLowerCase()) >= 0) {
          console.log(`A file named "` + this.files[i].name + `" was already selected!`);
          this.messageService.add({ severity: 'warn', summary: 'A file named "' + this.files[i].name + '" was already selected!', life: 5000 });
          this.files.splice(i, 1);  /*Since this method is the "files on change" method, we need to remove the duplicate file that was just added*/
          i--;
          newFileContainsDuplicate = true;
        }
        else {
          tempFiles.push(this.files[i].name.toLowerCase());
        }
      }
    }

    if(newFileContainsDuplicate == false) {
      this.base64FileContent = [];

      for(var i = 0; i < this.files.length; i++) {
        var file: File = this.files[i];
        if(file) {
          console.log(`Processing File: ${file.name}  ${file.size}`);

          var reader = new FileReader();
          reader.readAsBinaryString(file);
          reader.onload = (event) => { this.base64FileContent.push(btoa(event.target.result.toString())); };
        }
      }
    }
  }

  public uploadFilesClick() {
    this.fileUploading = true;
    var appendFiles = this.selectedRow.RequisitionTestResultId && this.uploadOption == "append"

    this.testReportingService.uploadReportDocuments(this.selectedRow.RequisitionId, this.selectedRow.RequisitionTestId, this.selectedRow.RequisitionTestResultId, this.selectedRow.LabSerialNumber, this.selectedRow.LabCode, this.selectedRow.FacilityCode, this.selectedRow.Lab_CLIA, this.base64FileContent, appendFiles).subscribe((data: any) => {
      var filesUploadCount = this.files.length;
      this.clearUploadFiles();
      this.showUploadDocument = false;
      this.loadGridData(this.lastLoad);
      this.fileUploading = false;
      this.messageService.add({ severity: 'success', summary: 'Files Uploaded', detail: `${filesUploadCount} files were uploaded to Accession  ${this.selectedRow.LabSerialNumber}` });
    }, (err) => {
      console.log(`Error: ` + err.error)
      this.fileUploading = false;
      this.messageService.add({ severity: 'error', summary: 'Error Uploading File ', detail: 'Failed: ' + err.error });
    });
  }

  public showFile(event, ind) {

    event.preventDefault();
    var f: File = this.files[ind];
    if (f) {
      var reader = new FileReader();
      reader.onload = (event) => {
        let file = new Blob([event.target.result], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        //this.pdfView = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
        window.open(fileURL);
      };
      reader.readAsArrayBuffer(f);
    }
  }

  public removeUploadFile(i) {
    this.files.splice(i, 1);
    if (this.files.length == 0) {
      this.uploadOption = null;
    }
  }

  public clearUploadFiles() {
    this.files.length = 0;
    this.uploadOption = null;
    this.base64FileContent = [];
  }

  public closeUploadDocument(value) {
    this.selectedRow = null;
    this.showUploadDocument = false;
    this.files.length = 0;
    this.showUploadOptions = false;
  }

  public removeToast() {
    this.messageService.clear();
  }
}
